// @core/api/endpoints/workflow/stop_debug_session.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DebugSessionResponse,
  StopDebugSessionRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Stop debug session
 * Stops a running debug session and cancels the associated execution.
 */
export async function StopDebugSession(
  session_id: string,
  data: StopDebugSessionRequest,
  options?: RequestOptions
): Promise<DebugSessionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/debug/:session_id/stop`;
  requestPath = requestPath.replace(':session_id', encodeURIComponent(session_id));
  const requestOptions = options;
  return client.post<DebugSessionResponse>(requestPath, data, requestOptions);
}
